import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {TranslateService} from '@ox/translate';
import {FormInput, TrackingService} from '@ox/utils';
import {takeWhile} from 'rxjs';

@Component({
  selector: 'ox-text-input',
  templateUrl: './text-input.component.html'
})
export class TextInputComponent implements OnInit {
  @Input() focusMe = '';
  @Input() pattern = '';
  @Input() classes = '';
  @Input() topDivClasses = '';
  @Input() inputDivClasses = '';
  @Input() errorDivClasses = '';
  @Input() inputElClasses = '';
  @Input() type = '';
  @Input() maxLength: number | undefined = undefined;
  @Input() minLength: number | undefined = undefined;
  @Input() required: boolean | string = false;
  @Input() validationType = '';
  @Input() tabIndex = '';
  @Input() inputName = '';
  @Input() placeHolderText = '';
  @Input() placeHolderId = '';
  @Input() label = '';
  @Input() id = '';
  @Input() isAriaRequired = false;
  @Input() ariaLabel: string | undefined = undefined;
  @Input() sup = '';
  @Input() supValue = '';
  @Input() textInput: FormControl | undefined = undefined;
  @Input() submitted = false;
  @Input() controlName = '';
  @Input() formGroup: FormGroup = this.createForm();
  @Input() iconLocation: boolean;
  @Output() focused: EventEmitter<boolean> = new EventEmitter();

  //NEW IMPLEMENATION FOR THE GIVING FORMGROUPS
  @Input() formGroupInput: FormGroup = this.createForm();

  // textInput is the default control if a form group and control isn't passed in
  @Input() formControlNameInput = 'textInput';

  // Passed in nestedFormGroup string when there is nested groups
  @Input() formGroupNameValue = '';

  public isNested = false;
  public priority = -2;
  public touched = false;
  //customError not being binded may cause problems when running angular
  public showCustomError = false;
  @Input() customTrackingErrorMessage = '';
  public displayInitError = false;
  public internalVal = false;
  public hasError = false;

  constructor(
    private fb: FormBuilder,
    private translate: TranslateService,
    private ocTrackingService: TrackingService
  ) {
  }

  public _errorVal = false;

  get errorVal(): boolean {
    return this._errorVal;
  }

  @Input()
  set errorVal(errorVal: boolean) {
    this._errorVal = errorVal;
    this.internalVal = errorVal;
  }

  @Input()
  set disabled(value: boolean | string) {
    value = value.toString();
    if (
      value === 'true' &&
      this.formGroupInput &&
      this.formGroupInput.controls[this.formControlNameInput]
    ) {
      this.formGroupInput.controls[this.formControlNameInput].disable();
    } else {
      this.formGroupInput?.controls[this.formControlNameInput].enable();
    }
  }

  ngOnInit(): void {
    /// If the placeholderId is passed into the component, this method looks it up against the collection of translations
    /// If the value is not found, then the placeHolderText value is used
    /// If neither is provided the placeholder attribute will be null
    if (
      this.internalVal && this.formGroupInput.controls[this.formControlNameInput].errors &&
      (this.formGroupInput.controls[this.formControlNameInput].errors?.['pattern'] ||
        this.formGroupInput.controls[this.formControlNameInput].errors?.['minlength'])
    ) {
      let errorMessage = this.inputName + '.invalidEntryError';
      //see customError initialization comment line 44
      if (this.customTrackingErrorMessage) {
        errorMessage = this.customTrackingErrorMessage;
      }
      this.ocTrackingService.trackEvent('event20', errorMessage, null, null);
    }
    if (
      typeof this.placeHolderId !== 'undefined' &&
      this.placeHolderId.length
    ) {
      this.translate.get(this.placeHolderId)
        .pipe(takeWhile(res => res !== this.placeHolderId))
        .subscribe((translations: string) => {
          this.placeHolderText = translations ?? this.placeHolderText;
        });
    }
  }

  createForm() {
    return this.fb.group({
      defaultValue: this.placeHolderText,
      // By default we will set the field to required
      // import forminput into component that needs validators, not done in bindings
      textInput: FormInput.generate({
        validators: {
          required: this.required,
          maxLength: this.maxLength,
          minLength: this.minLength,
          pattern: this.pattern
        }
      })
    });
  }

  showError() {
    let touched: boolean;
    const checkFormCtrl =
      this.formGroupInput?.controls[this.formControlNameInput];
    if (checkFormCtrl?.touched === undefined) touched = false;
    else {
      touched = checkFormCtrl.touched;
    }
    this.hasError =
      (touched || this.submitted) &&
      checkFormCtrl?.invalid !== undefined &&
      checkFormCtrl.invalid;
    return this.hasError;
  }

  public emitFocusState(state: boolean): void {
    this.focused.emit(state);
  }
}

